<div class="w-[738px] mx-[auto]  max-tablet:!w-full">
    <div class="px-[70px]  my-[80px] py-[39px] bg-[#fff] rounded-[16px] max-tablet:!px-[20px] max-tablet:mt-[0px] max-tablet:mb-[20px]" >
        <div class="flex flex-col items-center">
        <ErrorTipIcon></ErrorTipIcon>
        <div class="text-[#F84095] text-[18px] mt-[21px] text-center">
            {bodyText}
        </div>
        </div>
    </div>
</div>
<script lang="ts">
    import ErrorTipIcon from '$components/icons/ErrorTipIcon.svelte'
    export let bodyText = "";
</script>